// Collective-case retainer-round formula parser — DISPLAY HELPER ONLY.
//
// C.2 — the computation half (evalFormula / calcRound) moved server-side,
// VERBATIM, to server/src/lib/retainerRounds.js behind
// POST /api/retainer/compute (recording-proven bit-exact:
// recordings/c2-rounds/). The browser sends the rounds/members state and
// displays what it's handed — it computes no round money. What remains here
// is the formula-label formatter the retainer table header uses.
//
// (History: the trio was extracted verbatim from CollectiveCaseView.tsx in
// B.6 #124, frozen by its own characterization recording.)
export const fmtFormula = (formula: any) => {
  const fs = String(formula || "0").trim();
  if (fs.startsWith("=")) return fs;
  return fs.endsWith("%") ? fs : "x" + fs;
};

/* 208 §2 — A TRANCHE WITHOUT A FORMULA. A due follows the quantum only
   through its tranche's formula (the server's `calcRound`: « 5% », « 3 »,
   « =EXPR »); a tranche whose formula is empty, or a zero in any of the three
   grammars (« 0 », « 0% », « =0 », « 0,00 »), derives 0 from every quantum —
   which is what the import creates when its file states amounts, not rules
   (retainerImport.mjs `reconcileRounds`). The header says so instead of
   « (x0) », and the import summary says where the formula is set. */
export const formulaIsBlank = (formula: unknown): boolean => {
  const fs = (typeof formula === "string" || typeof formula === "number" ? String(formula) : "").trim();
  return fs === "" || /^=?\s*0+(?:[.,]0*)?\s*%?$/.test(fs);
};
